<sd-dropdown dropdownCustomId="dropdownHelp"
  [brand]="brand"
  [iconSize]="iconSize.small"
  icon="icon-help"
  [iconLabel]="'help.dropdown.label' | translate"
  [buttonIconTitle]="'help.dropdown.a11y.needHelp' | translate"
  [buttonIconTitleHidden]="true">
  <div class="c__logged-in" sd-dropdown-menu>
    <sd-title customClass="brand--h5 is-regular">
      {{ "help.dropdown.title" | translate }}
    </sd-title>
    <ul sd-list-block>
      @for (link of links; track link) {
        <li tabindex="1"
          class="c__option">
          <sd-link [link]="link"
            customClass="is-reset"
            [tabIndex]="1"
            (clicked)="closeDropdown()">
            {{ link?.linkName }}
          </sd-link>
        </li>
      }
    </ul>
  </div>
</sd-dropdown>
